export default "__VITE_ASSET__avZF840d__"